var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showFlugdetails)?_c('AufgabenFlugdetails',{attrs:{"reisetermine":_vm.reisetermine}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }